<template>
    <v-container class="py-12">
        <v-row>
            <v-col cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Novo Pedágio</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbs"></v-breadcrumbs>
                    </div>
                    <div>
                        <v-btn id="btnBack" type="button" outlined color="primary" elevation="0" @click="goBack">Voltar</v-btn>
                        <v-btn id="btnSave" type="submit" color="primary" elevation="0" class="ml-2" @click="createToll" :loading="loading">Salvar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="toll.name"
                                        label="Nome do Pedágio"
                                        :rules="[rules.required]"
                                        required
                                        dense
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                     <v-text-field
                                        v-model="toll.value"
                                        label="Valor do Pedágio"
                                        prefix="R$"
                                        :rules="[rules.required, rules.decimal]"
                                        required
                                        @input="formatValue"
                                        dense
                                        outlined
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    name: 'TollCreate',
    data: () => ({
        valid: true,
        loading: false,
        toll: {
            name: '',
            value: '0,00',
        },
        rules: {
            required: value => !!value || 'Campo obrigatório.',
            decimal: value => /^\d+(,\d{1,2})?$/.test(value) || 'Formato de valor inválido (ex: 12,50).',
        },
    }),
    computed: {
        breadcrumbs() {
            return [
                { text: 'Home', disabled: false, to: '/home', exact: true },
                { text: 'Pedagios', disabled: false, to: '/pedagios', exact: true },
                { text: 'Novo', disabled: true, exact: true },
            ];
        }
    },
    methods: {
        goBack() {
            this.$router.push('/pedagios');
        },
        formatValue() {
            let value = this.toll.value.replace(/\D/g, '');
            if (value) {
                value = (parseInt(value, 10) / 100).toFixed(2);
                value = value.replace('.', ','); 
            } else {
                value = '';
            }
            this.toll.value = value;
        },
        async createToll() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                try {
                    
                    const payload = {
                        ...this.toll,
                        value: parseFloat(this.toll.value.replace(',', '.'))
                    };

                    const response = await axios.post('/api/tolls', payload);
                    if (response.status === 201 || response.status === 200) {
                        this.$dialog.notify.success('Pedágio cadastrado com sucesso!', { position: 'top-right', timeout: 3000 });
                        this.goBack();
                    }
                } catch (error) {
                    console.error('Erro ao cadastrar pedágio:', error);
                    let errorMessage = "Erro desconhecido ao cadastrar pedágio.";
                    this.$dialog.notify.error(errorMessage, { position: 'top-right', timeout: 5000 });
                } finally {
                    this.loading = false;
                }
            }
        }
    }
};
</script>

